document.addEventListener('DOMContentLoaded', function() {
  
  const hcButtons = document.querySelectorAll('.collapsible-trigger-btn');
  const hcPopup = document.querySelector('.hc-popup-outer');
  const hcClose = document.querySelector('.hc-close');

  if(hcPopup){
    const hcAccordions = document.querySelectorAll('.hc-accordion');

    hcButtons.forEach(function(hcButton) {
      hcButton.addEventListener('click', function() {
        const hcAccordionActive = this.getAttribute('data-button');

        document.body.classList.add('hc-popup-opened');
        hcPopup.classList.add('show');
        hcAccordions.forEach(function(hcAccordion) {
          hcAccordion.classList.remove('hc-active');
        });

        document.querySelector('.hc-accordion[data-content="'+hcAccordionActive+'"]').classList.add('hc-active');

      });
    });

    hcClose.addEventListener('click', function() {
      document.body.classList.remove('hc-popup-opened');
      hcPopup.classList.remove('show');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.template-cart')) return;

  const hcNote = document.getElementById('hc-note');
  const note = document.getElementById('note');
  let originalNote = '';

  hcNote.value = '';
  note.value = '';

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const lineAttr = new Set();

      hcNote.value = '';
      note.value = '';
      
      cart.items.forEach(item => {
        const pnNote = item.properties?.['PN-Note']?.trim();
        const productTitle = item.title?.trim();
        if (pnNote) lineAttr.add(`${productTitle} - ${pnNote}`);
      });

      const currentNote = note.value.trim();
      if (currentNote) lineAttr.add(currentNote);

      originalNote = Array.from(lineAttr).join(', ');
      note.value = originalNote;
    });

  hcNote.addEventListener('input', () => {
    const hcValue = hcNote.value.trim();
    note.value = hcValue ? `${originalNote}, ${hcValue}` : originalNote;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;

  var $sliders = jQuery('.hc-rotation-slider');
  if (!$sliders.length) return;

  $sliders.each(function () {
    var $el = jQuery(this);
    if ($el.hasClass('slick-initialized')) return;

    $el.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      focusOnSelect: true
    });
  });
});

// Yotpo - match Trustpilot fonts
(function applyYotpoFonts() {
  function applyStyles() {
    var container = document.getElementById('yotpo-reviews-seo-page');
    if (!container) return false;

    container.querySelectorAll('*').forEach(function(el) {
      el.style.setProperty('font-family', '"Nunito Sans", sans-serif', 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('color', '#676869', 'important');
    });

    container.querySelectorAll('h3.yotpo-review-title').forEach(function(el) {
      el.style.setProperty('font-family', 'Lora, serif', 'important');
      el.style.setProperty('font-size', '18px', 'important');
      el.style.setProperty('line-height', '1.3', 'important');
    });

    return true;
  }

  var observer = new MutationObserver(function() {
    if (applyStyles()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', applyStyles);
})();

document.addEventListener('DOMContentLoaded', function () {
  var resizeTimer;

  function syncTabsContentMobileState() {
    var sections = document.querySelectorAll('[data-section-type="tabs-content"] .cc-tabs');

    sections.forEach(function (tabsContainer) {
      var breakpoint = parseInt(tabsContainer.dataset.mobileBreakpoint, 10) || 767;
      var isMobile = window.innerWidth <= breakpoint;
      var items = Array.from(tabsContainer.querySelectorAll('[data-tab-item]'));
      var triggers = Array.from(tabsContainer.querySelectorAll('[data-tab-trigger]'));
      var panels = Array.from(tabsContainer.querySelectorAll('[data-tab-panel]'));

      if (!isMobile || !items.length) return;

      var activeIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      items.forEach(function (item, index) {
        var isActive = index === activeIndex;
        var trigger = triggers[index];
        var panel = panels[index];

        item.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.tabIndex = 0;
        panel.hidden = !isActive;
      });
    });
  }

  syncTabsContentMobileState();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncTabsContentMobileState, 80);
  });
});

// smooth-scroll "Read Full Description" to its target instead of the browser's instant jump -
// the description now renders twice (desktop copy under the gallery, mobile copy in the lower
// row, see main-product.liquid), each with its own id, so the link carries both as data
// attributes and picks whichever one is actually on screen at the 768px mobile-only/desktop-only
// breakpoint. Both targets have scroll-margin-top set (in hc-custom.css) to clear the sticky
// header, and scrollIntoView respects that same offset.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.read-full-description-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var isDesktop = window.matchMedia('(min-width: 768px)').matches;
      var targetId = isDesktop
        ? this.getAttribute('data-target-desktop')
        : this.getAttribute('data-target-mobile');
      if (!targetId) return;

      var target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});

// clicking the star rating beside the price scrolls to the full-width reviews section -
// delegated on document since the widget's inner content is filled in later by Yotpo's JS
document.addEventListener('click', function (e) {
  var starRating = e.target.closest('.pdp-star-rating');
  if (!starRating) return;

  var target = document.getElementById('hc-page-reviews');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
